import '../utils/polyfills'
// ↑ should be at the top of file
import '../app/util/sentry/initSentry'
import '../globals-import'
import { renderLooopApp } from '../components/LooopApp'
import environment from 'shared/environment'

window['__DEV__'] = environment.isDevelopment() // this global is used by the apollo client-without it HMR rerendering checks inside apollo-client break

if (location.port === '' || location.port !== '3000') {
  // if running from local bundle or on prod we print out the git version
  console.info(window.LOOOP)
}

const splash = document.getElementsByClassName('splash')[0] as HTMLElement
splash.style.display = 'none'
;(async () => {
  renderLooopApp()
})()
